module.exports = new __parcel__URL__("Hiring Process Hover.c4281ae3.svg").toString();